export default __webpack_public_path__ + "static/xm-e4a8ba3a220b9704f1c2516574d404a8.png";